import { useEffect, useState } from 'react';

const MIN_SUPPORTED_WIDTH = 1440;

// The window, not the viewport (which shrinks under zoom) and not the screen (which
// ignores the window): outerWidth follows a resize and holds still on zoom. Chrome
// reports it as 0 for a background tab, so fall back to the layout viewport until
// the tab is visible again and the check can re-run against a real width.
function getIsScreenTooSmall() {
  const width = window.outerWidth || window.innerWidth;
  return width <= MIN_SUPPORTED_WIDTH;
}

export function useIsScreenTooSmall() {
  const [isSmall, setIsSmall] = useState(getIsScreenTooSmall);

  useEffect(() => {
    const update = () => setIsSmall(getIsScreenTooSmall());
    update();
    window.addEventListener('resize', update);
    window.addEventListener('pageshow', update);
    document.addEventListener('visibilitychange', update);
    return () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('pageshow', update);
      document.removeEventListener('visibilitychange', update);
    };
  }, []);

  return isSmall;
}
